import type { GameConfig } from '../../config/gameConfig';
import { BasicUnitType, UnitRoster, type UnitTypeConfig } from './units';

export function buildUnitRoster(config: GameConfig): UnitRoster {
    const types = [
        ...Object.values(config.battle.units),
        ...Object.values(config.battle.enemies),
    ].map((entry) => new BasicUnitType(entry));
    return new UnitRoster(types);
}

export function getPlayerUnitConfigs(config: GameConfig): UnitTypeConfig[] {
    return Object.values(config.battle.units);
}
